import { Controller } from "@hotwired/stimulus"

class Autocomplete extends Controller {
  static targets = ["input", "option", "empty"]
  static hiddenClass = "-hidden"
  static activeClass = "-active"
  static values = { options: String }

  connect() {
    this._initializeOptions()
    const checkedRadioInput = this.element.querySelector("input:checked")
    checkedRadioInput && this._updateLabel(checkedRadioInput.value)
  }

  _initializeOptions() {
    this.options = JSON.parse(this.optionsValue)
  }

  _updateLabel(value) {
    this.inputTarget.value = this.options[value]
    this.toggleOptions()
  }

  select(e) {
    this.optionTargets.forEach((optionElement) => {
      optionElement.classList.remove(Autocomplete.activeClass)
    })
    const input = e.target.parentNode
    input.classList.add(Autocomplete.activeClass)
    this._updateLabel(e.target.value)
  }

  toggleOptions() {
    const text = this.inputTarget.value.toLowerCase()

    if (text === "") {
      this.optionTargets.forEach((optionElement) => {
        optionElement.classList.remove(Autocomplete.hiddenClass)
      })
      return
    }

    this.optionTargets.forEach((optionElement) => {
      if (!optionElement.innerText.toLowerCase().includes(text)) {
        optionElement.classList.add(Autocomplete.hiddenClass)
      } else {
        optionElement.classList.remove(Autocomplete.hiddenClass)
      }
    })

    if (this.optionTargets.length === this.optionTargets.filter(e => Array.from(e.classList).includes(Autocomplete.hiddenClass)).length) {
      this.emptyTarget.classList.remove(Autocomplete.hiddenClass)
    } else {
      this.emptyTarget.classList.add(Autocomplete.hiddenClass)
    }
  }
}

export { Autocomplete }
